import { NavParams, ViewController, App, AlertController, LoadingController, NavController } from "ionic-angular";
import { Component, ElementRef } from "@angular/core";
import {LoginPage} from "../login/login";
import {AppDialog} from "../../component/appDialog";
import { UserService } from "../../services/user.services";
import {AppConfigService} from "../../services/appConfig.service";
import {ImproveUserPage} from "../improveUser/improveUser";
import {TabsPage} from "../tabs/tabs";
import { CommonService } from "../../services/common.service";
import {UserEditPage} from "../userEdit/userEdit";
import {HomePage} from "../home/home";
import {AppConfig} from "../../util/appConfig";

@Component({
    templateUrl: 'userTest.html',
    selector: 'user-test',
})

export class UserTest {
    private getUserName: string;
    private getPass: string;
    private getBalance: string;
    private flagVerifyPhone: number;

    constructor(public viewCtrl: ViewController, public el: ElementRef, public params: NavParams,
                public userService: UserService, public app: App, public alertCtrl: AlertController,
                public loadingCtrl: LoadingController, private nav: NavController, public common: CommonService){
        this.flagVerifyPhone = common.flagVerifyNumber;
        if (common.flagVerifyNumber) { // is verify phone number
            this.getUserName = params.data['userData'].loginname;
            this.getPass = params.data['userData'].pwd;
            this.getBalance = this.common.numberWithCommas(params.data['userData'].blance);
        }
    }

    dismissAccountTest() {
        this.viewCtrl.dismiss();
    }

    loginAccountTest() {
        this.userService.loginOut(undefined, this).then(data => {
            if (data["msg"] == "") {
                this.viewCtrl.dismiss();
                setTimeout(() => {
                    let user = {
                        un: this.getUserName.toLowerCase(),
                        pwd: this.getPass,
                        ver: AppConfig.Version
                    };
                    this.userService.login(user, this).then(data => {
                        if (data["msg"] == "") {
                            this.common.userType = data['user'].usertype;
                            AppConfigService.sid = data["SessionId"];
                            this.app.getRootNav().push(TabsPage, {
                                paramUser: data["user"]
                            });
                        } else {
                            if (data["msg"] == "-1") {
                                this.nav.push(ImproveUserPage, {
                                    paramUser: data["user"]
                                });
                            } else {
                                AppDialog.alert({
                                    alertCtrl: this.alertCtrl,
                                    message: data["msg"],
                                    callBack: () => {
                                        this.app.getRootNav().setRoot(LoginPage);
                                        this.common.userType = 0; // to hide top header 'Bạn đăng ở tài khoản chơi thử'
                                    }
                                });
                            }
                        }
                    });
                }, 200);
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    gotoVerifyPage(ev: any) {
        this.viewCtrl.dismiss();
        this.app.getRootNav().push(UserEditPage, {
            userData: this.params.data['userData'],
            selectAction: true
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/userTest/userTest.ts